import {
  NavigationContainer,
  useNavigation,
  useNavigationState,
} from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { useEffect, useRef, useState } from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import HomePage from "../features/homescreen/pages/HomePage";
import TermsOfServicePage from "../features/terms/pages/TermOfServicePage";
import navigationNames from "./navigationNames";
import JutaAppIcon from "../assets/icons/juta-app-icon.png";
import TextPrimary from "../shared-components/text/TextPrimary";
import HeaderRight from "./components/HeaderRight";
import HeaderLeft from "./components/HeaderLeft";
import PrivacyPolicyPage from "../features/privacy/pages/PrivacyPolicyPage";
import * as Linking from "expo-linking";

const RootStackNavigation = () => {
  const Stack = createStackNavigator();
  const navigation = useNavigation();
  // const navigation = useNavigationState((state) => state);
  const [path, setPath] = useState<string | any>(navigationNames.home.id);
  const url = Linking.useURL();

  useEffect(() => {
    if (url) {
      const { hostname, path, queryParams } = Linking.parse(url);
      setPath(path);
    }
  }, [url]);
  
  useEffect(() => {
    
  },[path])
  return (
    <>
      <Stack.Navigator
        initialRouteName={path}
        screenOptions={{
          cardStyle: { flex: 1 },
          headerStyle: {
            backgroundColor: "transparent",
          },
          headerShadowVisible: false,
          headerLeft: () => (
            <>
              <HeaderLeft
                onPress={(pageName, config) => {
                  navigation.navigate(pageName, config);
                }}
              />
            </>
          ),
          headerRight: () => (
            <>
              <HeaderRight
                onPress={(pageName, config) => {
                  navigation.navigate(pageName, config);
                }}
              />
            </>
          ),
        }}
      >
        <Stack.Screen
          options={{
            title: navigationNames.home.title,
          }}
          name={navigationNames.home.id}
          component={HomePage}
        />
        <Stack.Screen
          options={{
            title: navigationNames.termsOfService.title,
          }}
          name={navigationNames.termsOfService.id}
          component={TermsOfServicePage}
        />
        <Stack.Screen
          options={{
            title: navigationNames.privacyPolicy.title,
          }}
          name={navigationNames.privacyPolicy.id}
          component={PrivacyPolicyPage}
        />
      </Stack.Navigator>
    </>
  );
};

export default RootStackNavigation;
